module.exports = __webpack_public_path__ + "media/success.ebe3c7cd.mp3";